import { render, staticRenderFns } from "./ModifyTranslations.vue?vue&type=template&id=4f00c3ac&scoped=true&"
import script from "./ModifyTranslations.vue?vue&type=script&lang=js&"
export * from "./ModifyTranslations.vue?vue&type=script&lang=js&"
import style0 from "./ModifyTranslations.vue?vue&type=style&index=0&id=4f00c3ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f00c3ac",
  null
  
)

export default component.exports